import { publicUrl } from "../utils/publicUrl.js";

export const UI_ICON_SIZES = {
  small: 64,
  medium: 128,
  large: 256,
};

export function uiIconUrl(key, size = UI_ICON_SIZES.small) {
  const safeKey = String(key || "").toLowerCase().replace(/[^a-z0-9_]+/g, "_");
  const safeSize = Number(size) || UI_ICON_SIZES.small;
  return publicUrl(`ui/icons/${safeSize}/${safeKey}.png`);
}

export function uiSpriteUrl(key, size = 512) {
  const safeKey = String(key || "").toLowerCase().replace(/[^a-z0-9_]+/g, "_");
  const safeSize = Number(size) || 512;
  return publicUrl(`ui/sprites/${safeSize}/${safeKey}.png`);
}

export function uiBackgroundUrl(key, size = 1024) {
  const safeKey = String(key || "").toLowerCase().replace(/[^a-z0-9_]+/g, "_");
  const safeSize = Number(size) || 1024;
  return publicUrl(`ui/backgrounds/${safeSize}/${safeKey}.png`);
}

export function getAbilityIconKeyByName(abilityName) {
  const name = String(abilityName || "").toUpperCase();
  if (name.includes("RAGE") || name.includes("UNHINGED") || name.includes("VECTOR")) return "ability_rage_ram";
  if (name.includes("DRONE") || name.includes("DISTRIBUTED") || name.includes("PRESENCE")) return "ability_multiveil";
  if (name.includes("CHARGE")) return "ability_gray_matter";
  if (name.includes("PHASE") || name.includes("CLOAK") || name.includes("SPECTRAL") || name.includes("STRIKE")) return "ability_chroma";
  if (name.includes("LOGISTICS") || name.includes("SWARM") || name.includes("CHAIN")) return "ability_fulfillment";
  return null;
}
